export default "__VITE_ASSET__CwtcmesE__"